import { useSelector } from 'react-redux';
import usePermissions from './usePermissions';
import canSeeFinance from '../utils/canSeeFinance';

/**
 * useMontantsEchange — « ai-je le droit de voir l'argent d'un échange ? »
 *
 * POURQUOI UN ENDROIT UNIQUE. La règle était écrite quatre fois dans le
 * parcours d'échange, et elle avait déjà divergé : le catalogue de sélection,
 * le récapitulatif et le tableau des lignes la posaient comme
 * `canSeeFinance(user)` (donc admin seul), pendant que l'historique du Centre
 * des échanges affichait l'écart de prix SANS aucune garde. Une secrétaire
 * voyait donc l'écart d'un échange terminé, mais pas celui qu'elle était en
 * train de préparer. Une règle recopiée est une règle qui se périme.
 *
 * CE QUI A CHANGÉ (30/08/2026). Décision de la propriétaire : « les secrétaires
 * doivent voir le prix et l'écart ». On l'exprime en PERMISSION, pas en rôle
 * codé en dur — même choix qu'en juillet pour `depenses.voir_montants`. Une
 * permission se retire dans la matrice ; un `role === 'secretaire'` écrit dans
 * le code demande un développeur et un déploiement.
 *
 * `canSeeFinance` reste le premier terme : l'admin voit tout, sans dépendre
 * d'une ligne en base qu'un nettoyage pourrait emporter.
 *
 * ⚠ VOIR N'EST PAS CORRIGER. Le bouton « Corriger le prix » du récapitulatif
 * dépend d'une AUTRE clé, `retours.ajuster_prix`, tranchée par le serveur
 * (`apercu.peut_ajuster`). Rendre le montant lisible ne le rend pas modifiable.
 *
 * ⚠ `can()` répond faux tant que les droits ne sont pas chargés. Pour l'admin
 * le premier terme suffit donc immédiatement ; pour une secrétaire les montants
 * apparaissent au retour de `/api/permissions/me`. Même comportement que
 * l'écran Dépenses, qui vit avec depuis juillet.
 */
export default function useMontantsEchange() {
  const user = useSelector((state) => state.user?.currentUser);
  const { can } = usePermissions();
  return canSeeFinance(user) || can('retours.voir_montants');
}
